import "./loader.css";

const Loader = () => {
    return (
        <div className="loader">
            <div className="gum-wrapper">
                <div className="gum"></div>
                <div className="gum"></div>
                <div className="gum"></div>
                <div className="gum"></div>
                <div className="gum"></div>
            </div>

        </div>
    );
};

export default Loader;
